import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserService } from 'app/services/user.service';
import { UnitService } from 'app/services/unit.service';

declare var swal:any;

@Component({
  selector: 'app-user-edit-dialog',
  templateUrl: './user-edit-dialog.component.html',
  styleUrls: ['../../app.component.css','./user-edit-dialog.component.css'],
  providers: [ UserService, UnitService ]
})
export class UserEditDialogComponent  {

    public entity;
    public units;

    constructor(
        public userService: UserService,
        public unitService: UnitService,
        public dialogRef: MatDialogRef<UserEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data:any
    ) {
        if (this.data.id_clientes) {
            this.unitService.getResources().subscribe((response:any) => {
                this.units = response.data.unidades;
            });

            this.userService.getUserData(this.data.id_clientes).subscribe((response:any) => {
                this.entity = {
                    name: response.data.user_info.user_name,
                    email: response.data.user_info.user_email,
                    role: response.data.user_info.user_role,
                    keys: Object.keys(response.data.value),
                    value: response.data.value
                };

            });
        }
    }

    saveUser() {
        this.userService.saveData(this.entity, this.data.id_clientes).subscribe(response => {
            swal({
                type: 'success',
                title: 'Bom trabalho!',
                text: response.mensagem,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success'
            });
            this.dialogRef.close();
        });
    }
    
    onNoClick(): void {
        this.dialogRef.close();
    }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/user-edit-dialog/user-edit-dialog.component.ts